export enum TimelineNboApproval {
  D_NBO_DP_N2 = 'D_NBO_DP_N2',
  D_NBO_DP_N1 = 'D_NBO_DP_N1',
  D_NBO_G_OPEA = 'D_NBO_G_OPEA',
}
